// UI-only stable id for React keys (backend mein nahi jaata)
let _id = 0;
export const uid = () => `f${++_id}`;

// label -> safe key (jaise "Your Name" -> "your_name")
export const slugify = (s) =>
  (s || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .replace(/^([0-9])/, "field_$1")
    .slice(0, 50) || "field";

// naya field banata hai sensible defaults ke saath
export function makeField(type, index) {
  const base = {
    id: uid(),
    type,
    label: "Untitled field",
    key: `field_${index + 1}`,
    required: false,
  };
  if (type === "select") base.options = ["Option 1", "Option 2"];
  if (type === "image_multi") base.maxItems = 4;
  if (["text", "textarea", "number"].includes(type)) {
    base.min = null;
    base.max = null;
  }
  return base;
}

// fields ko save se pehle validate karta hai -> error string ya null
export function validateFields(fields) {
  const keys = new Set();
  for (const f of fields) {
    if (!/^[a-zA-Z][a-zA-Z0-9_]{0,49}$/.test(f.key))
      return `Invalid key: ${f.key}`;
    if (keys.has(f.key)) return `Duplicate key: ${f.key}`;
    keys.add(f.key);
    if (f.type === "select" && !(f.options || []).length)
      return `Dropdown "${f.key}" needs options`;
  }
  return null;
}

// backend ke liye payload (UI-only `id` strip)
export const toPayload = (form) => ({
  name: form.name,
  strict: form.strict,
  fields: form.fields.map(({ id, ...rest }) => rest),
});

// backend se aaye fields ko UI ke liye id assign
export const fromSchema = (schema) => ({
  name: schema.name,
  strict: schema.strict ?? true,
  fields: (schema.fields || []).map((f) => ({ ...f, id: uid() })),
});
